import React from "react";
import { components } from "react-select";
import InvestmentItemAvatar from "../mui/material/InvestmentItemAvatar";
var InvestmentItemSingleValue = function InvestmentItemSingleValue(props) {
  return /*#__PURE__*/React.createElement(components.SingleValue, props, props.data.value && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(InvestmentItemAvatar, {
    size: "sm",
    investmentItem: props.data
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 ps-2"
  }, props.data.symbol && /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, props.data.symbol, "\xA0|\xA0"), props.data.name)));
};
export default InvestmentItemSingleValue;